import React, { useEffect, useState } from "react";
import PageHero from "@/components/public/PageHero";
import { INSTRUMENTS, tick } from "@/lib/market";
import { useLiveRates, mergeLive, anyLive } from "@/lib/liveRates";
import Sparkline from "@/components/public/Sparkline";
import { useSite } from "@/context/SiteContext";

export default function Markets() {
  const { trackAndGo } = useSite();
  const cats = Object.keys(INSTRUMENTS);
  const [active, setActive] = useState(cats[0]);
  const { live } = useLiveRates();
  const [rows, setRows] = useState(INSTRUMENTS[cats[0]]);
  useEffect(() => setRows(mergeLive(INSTRUMENTS[active], live)), [active, live]);
  useEffect(() => {
    const id = setInterval(() => setRows((p) => p.map((r) => ({ ...r, p: tick(r.p) }))), 1600);
    return () => clearInterval(id);
  }, [active]);
  const isLive = anyLive(rows);

  return (
    <div>
      <PageHero overline="Markets" title="Trade 120+ Global Instruments" subtitle="Forex, Metals, Commodities, Indices, Stocks and Crypto — all from a single account." image="/images/hero_global_finance.jpg" />
      <section className="py-16 sm:py-24 bg-white">
        <div className="cb-container">
          <div className="flex flex-wrap gap-2 mb-6">
            {cats.map((c) => (
              <button key={c} onClick={() => setActive(c)} className={`px-4 py-2 text-sm rounded transition-colors ${active === c ? "btn-gold" : "text-slate-700 border border-slate-200 hover:border-[#D8AE4E]/50"}`} data-testid={`markets-tab-${c.toLowerCase()}`}>{c}</button>
            ))}
          </div>
          <div className="cb-card overflow-hidden">
            <table className="w-full text-sm">
              <thead><tr className="text-left text-slate-500 border-b border-slate-200">
                <th className="px-6 py-3 font-medium">Instrument</th>
                <th className="px-6 py-3 font-medium text-right">Bid</th>
                <th className="px-6 py-3 font-medium text-right">24h</th>
                <th className="px-6 py-3 font-medium text-center hidden md:table-cell">Trend</th>
                <th className="px-6 py-3 font-medium text-right">Action</th>
              </tr></thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.s} className="border-b border-slate-200 last:border-0 hover:bg-[#F1F5F9] transition-colors">
                    <td className="px-6 py-4 font-mono text-slate-700">{r.s}</td>
                    <td className="px-6 py-4 font-mono text-[#0B1D40] text-right">{r.p}</td>
                    <td className={`px-6 py-4 font-mono text-right ${r.d >= 0 ? "ticker-up" : "ticker-down"}`}>{r.d >= 0 ? "+" : ""}{r.d}%</td>
                    <td className="px-6 py-4 text-center hidden md:table-cell" data-testid={`markets-spark-${r.s.replace(/\W/g, "")}`}><Sparkline value={r.p} up={r.d >= 0} /></td>
                    <td className="px-6 py-4 text-right"><button onClick={() => trackAndGo("live_register")} className="btn-outline-gold px-4 py-1.5 text-xs" data-testid={`markets-trade-${r.s.replace(/\W/g, "")}`}>Trade</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p className="text-xs text-slate-500 mt-4 inline-flex items-center gap-1.5" data-testid="markets-data-status">
            <span className={`w-1.5 h-1.5 rounded-full ${isLive ? "bg-emerald-500 animate-pulse" : "bg-amber-400"}`} />
            {isLive
              ? "Live prices streamed from our market data provider. Other instruments are indicative."
              : "Data delayed — indicative values shown. Live pricing streams on the trading platform."}
          </p>
        </div>
      </section>
    </div>
  );
}
